export default "__VITE_ASSET__1631401e__"